module.exports = __webpack_public_path__ + "static/media/sqlserver.e4d536b1.png";